import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaybookService } from './paybook.service';
import { PaybookComponent } from './paybook.component';
import { HttpModule } from '@angular/http';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
  ],
  declarations: [
    PaybookComponent,
  ],
  exports: [
    PaybookComponent,
  ],
  providers: [
    PaybookService
  ]
})
export class PaybookModule { }



// WEBPACK FOOTER //
// ./src/app/paybook/paybook.module.ts